import { hasFixedPosition, containEvent } from './utilities';

const panels = []

function hidePanels() {
  panels.forEach((panel) => {
    panel.hide();
  });
}

function hidePanelsExcept(this_panel) {
  panels.forEach((panel) => {
    if (panel !== this_panel) panel.hide();
  });
}

class Panel {
  constructor(el) {
    this.container = el;
    this.panel_name = el.dataset.panel;
    this.header = document.querySelector(`a[data-panel='${this.panel_name}']`)
    this.timer = null;
    this.showing = false;

    // show panel on click or hover
    this.header.addEventListener('click', this.click.bind(this));
    this.header.addEventListener('mouseenter', this.hover.bind(this));
    this.header.addEventListener('mouseleave', this.hideSoonIfHovered.bind(this));
    this.container.addEventListener('mouseleave', this.hideSoonIfHovered.bind(this));
    this.container.addEventListener('mouseenter', this.dontHide.bind(this));

    // show panel by triggering 'show' event on container
    this.container.addEventListener('show', this.show.bind(this));
    this.container.addEventListener('hide', this.hide.bind(this));

    document.querySelectorAll(`a[data-showpanel='${this.panel_name}']`).forEach((a) => {
      a.addEventListener('click', this.click.bind(this));
    });

    this.container.querySelectorAll("a.close").forEach((a) => {
      a.addEventListener('click', this.hide.bind(this));
    });

    this.prepareElements();
    panels.push(this);
  }

  prepareElements() {
    // patch sits over the join between header and body to cover up shadow
    if (!this.patch) {
      this.patch = document.createElement('div');
      this.patch.classList.add('patch');
      this.patch.dataset.panel = this.panel_name;
      this.container.appendChild(this.patch);
    }

    const rect = this.header.getBoundingClientRect();
    this.patch.style.width = `${rect.width - 2}px`;
    this.container.style.right = `${window.innerWidth - rect.right - 12}px`;

    let place_above;
    if (hasFixedPosition(this.header)) {
      place_above = rect.bottom > window.innerHeight - 140;
    } else {
      place_above = rect.bottom > document.body.clientHeight - 140;
    }

    if (place_above) {
      const bottom = window.innerHeight - 4 - rect.top;
      this.container.classList.add('above');
      this.container.classList.remove('below');
      this.header.classList.add('above');
      this.header.classList.remove('below');
      this.container.style.bottom = `${bottom}px`;
    } else {
      const top = rect.bottom - 4;
      this.container.classList.remove('above');
      this.container.classList.add('below');
      this.header.classList.remove('above');
      this.header.classList.add('below');
      this.container.style.top = `${top}px`;
    }
    this.header.classList.add('ready');
    this.container.classList.add('ready');
  }

  show(e) {
    containEvent(e);
    hidePanelsExcept(this);
    this.dontHide();
    this.container.classList.add('up');
    this.header.classList.add('up');
    const field = this.container.querySelector('input[autofocus]');
    if (field) field.focus();
  }

  click(e) {
    containEvent(e);
    if (!this._hovering && this.container.classList.contains('up')) {
      this.hide();
    } else {
      this.show();
    }
    this._hovering = false;
  }

  hover(e) {
    containEvent(e);
    this.show();
    this._hovering = true;
  }

  hideSoonIfHovered(e) {
    containEvent(e);
    if (this._hovering) this.hideSoon();
  }

  hide(e) {
    containEvent(e);
    if (this.container.classList.contains('up')) {
      this.container.classList.remove('up');
      this.header.classList.remove('up');
      this._hovering = false;
    }
  }

  hideSoon() {
    this.timer = window.setTimeout(this.hide.bind(this), 500);
  }

  dontHide(e) {
    if (this.timer) window.clearTimeout(this.timer)
  }
}

function panel(el) {
  return new Panel(el);
}

export default panel; 